export default __webpack_public_path__ + "static/media/logo2024.89ade097.png";